import { Component } from '@angular/core';
import { DateInputComponent } from './date-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputKeyDirective } from '../../form.directive';
import { BlockPasteEventDirective } from '../../directives/block-paste-event.directive';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-datepicker-input',
  templateUrl: './datepicker-input.component.html',
  imports: [FormsModule, InputKeyDirective, ReactiveFormsModule, BlockPasteEventDirective, NgClass, TranslatePipe],
})
export class DatepickerInputComponent extends DateInputComponent {}
